import './about.css'
import iconContact from '../../assets/phone-solid (1).svg'
import imgabout from '../../assets/h.jpg'
import { NavLink } from 'react-router-dom'
function About(){
    return <div className="bg-about">
        <div id="bg-about">

        <div className="textHome">
                <div className="bigText">
                    <h1>Qui sommes NOUS</h1>
                    {/* <img src={''} alt="code image"  /> */}
                </div>
                <h3>Nous sommmes la pour vous facilité la vie</h3>
                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. A, dolor repellendus eveniet quos nemo asperiores tempore est possimus esse saepe ipsam consectetur aspernatur nesciunt consequatur ducimus non placeat, eius voluptatibus!</p>
                <NavLink to='/contact' className="contactUs">
                    <img src={iconContact} style={{width:'30px'}} alt="icon sub"  />
                    Nous contacter</NavLink>
            </div>
            <div className="imgAbout">
                <img src={imgabout} alt={'image iot'} />
            </div>
        </div>
    </div>
}
export default About